export const BRP_FINANCIAL_IDENTIFIER = "brp-financial";
export const BUFFALO_IDENTIFIER = "buffalo";

export const isBrpFinancialIdentifier = (identifier) =>
   identifier === BRP_FINANCIAL_IDENTIFIER || identifier === BUFFALO_IDENTIFIER;

/**
 * CAP-881: Legal-approved label for the Buffalo/BRP data sharing consent checkbox.
 *
 * Defined once and shared by both prequal surfaces that render the checkbox
 * (long-prequal-step and prequal/about-you) so the copy cannot drift between them —
 * the acceptance criteria require it to match Legal's text exactly.
 *
 * "Data Sharing Authorization Disclosures" is bold and links to the full disclosure,
 * which opens in the global RideOctaneModal via the #modal= hash route rather than
 * navigating away from the application.
 */
export const BRP_SHARING_CONSENT_LABEL =
   'By checking this box and submitting this application, you are agreeing to the following [**Data Sharing Authorization Disclosures**](#modal=data_sharing_authorization_disclosure), which authorizes Octane Lending, Inc. and its subsidiary, Roadrunner Financial, Inc. (collectively "OL"), to share your nonpublic personal information contained in this application with OL’s non-affiliated 3rd party service providers and business partners, beginning 30 days after the date of this application submission. You understand that you can revoke this authorization at any time.';

/**
 * Legal disclosure that must appear on every page carrying the BRP Financial
 * Services branding (CAP-570). Legal-approved — do not edit, reword, or
 * truncate without sign-off.
 *
 * Defined once and imported everywhere it renders so the copy cannot drift
 * between surfaces. Render through DisclosureBlock WITHOUT `showCheckBox`: it
 * must stay non-interactive and always visible (no links, no dismiss).
 */
export const BRP_FINANCIAL_DISCLOSURE =
   '"BRP Financial Services" is a program brand name owned by Bombardier Recreational Products, Inc. or its affiliates (BRP) that promotes the availability of credit offered solely by Roadrunner Financial, Inc. (RF) (NMLS ID 1525116) for certain consumer credit plans extended through participating dealers to borrowers. BRP is solely responsible for its vehicle products and product-related services. Financing provided by RF is subject to credit approval, terms, and conditions. Roadrunner Account Services, LLC (NMLS ID 1758660) services these accounts on behalf of their owner, RF or its assignee. RF and Roadrunner Account Services, LLC are not affiliated with BRP or its affiliates.';
